import { MutableRefObject, useRef, useState } from "react"
import { produce } from "immer"
import { HxMapGroup } from "../../../Comps/HxMap/HxMapGroup";
import { NoteButtons } from "../../../Comps/NoteButtons/NoteButtons";
import { HexMap } from "../../../Data/HexMap/HexMap";
import { HexMapBuilderParams, BuildHexMap } from "../../../Data/HexMap/HexMapBuilder";
import { HexMapModifier } from "../../../Data/HexMap/HexMapModifier";
import { Note } from "../../../Data/HexMap/Note";
import { All } from "../../../Util/Constants/Quantities";
import { Music } from "../../../Util/Music/Music";
import { TransformTranslate } from "../../../Util/Transform/Transform";
import { motion } from "motion/react";
import { BsCheckCircle, BsXCircle } from "react-icons/bs";
import { ClassNames } from "../../../Util/ClassNames";
import { Key } from "../../../Data/HexMap/Key";
import { ExerciseMessage } from "../Utils/Message/ExerciseMessage";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { NotePlayer } from "../../../Sound/NotePlayer";
import { useNotePlayer } from "../../../Sound/SoundStore";

export function HexMapBuilder(){
    const initialNote:number = 9
    const [complete, setComplete] = useState<boolean>(false)
    const selectedNote:MutableRefObject<number> = useRef(initialNote)
    const tonic:MutableRefObject<number> = useRef(Music.Gb)
    const getInitialMessage = () => {
        return 'Complete each key of this HexMap Pattern. Select a note and define it.'
    }
    const [message, setMessage] = useState(getInitialMessage())
    const answerIs:MutableRefObject<boolean|null> = useRef(null)
    const checkForCompletion = (draft:HexMap) => {
        const allKeyNotesDefined = (key:Key) => {
            for(let noteIndex of key.noteIndexes){
                if(!draft.notes[noteIndex].defined){return(false)}
            }
            return true
        }
        let allNotesDefined:boolean = true
        draft.keys.flat().forEach((key:Key)=>{
            if(allKeyNotesDefined(key)){
                key.selectedState = Note.SelectedState_Selected
            }
            else{
                allNotesDefined = false
            }
        })
        return allNotesDefined
    }
    const onNoteClick = (note:Note) => { // handler - converted
        if(!note.defined){
            const currentNoteIsDefined:boolean = map.notes[selectedNote.current].defined
            const currentIndex:number = selectedNote.current
             setMap(produce((draft:HexMap)=>{ 
                mod.current.setDraft(draft)
                mod.current.notes_setHilited([note.params.noteIndex])
                if(currentNoteIsDefined){
                    mod.current.notes_setSelected([currentIndex])
                }
                else{
                    mod.current.notes_setDefault([currentIndex])
                }
            }))

            selectedNote.current = note.params.noteIndex
            setMessage('OK. Now define this note.')
            return
        }
        setMessage('This note is already defined.')
        notePlayer.current.playBuzzer()
        answerIs.current = false
        setTimeout(resetMessageForNextNote, 1000)
    }
    const onKeyClick = ()=>{}
    const getHexMap = () => {
        const initializeMap = (modifier:HexMapModifier) => {
            modifier.notes_setDefined([All], false)
            modifier.notes_setDefined([initialNote], true)
            modifier.notes_setSelected([initialNote])
        }
        const params:HexMapBuilderParams = {
            rows:3, columns:4, tonic:tonic.current, radius:60
        }
        const map:HexMap = BuildHexMap(params)
        const mod:HexMapModifier = new HexMapModifier(map)
        initializeMap(mod)
        return map
    }
    const [map, setMap] = useState(getHexMap())
    const mod:MutableRefObject<HexMapModifier> = useRef(new HexMapModifier(map))
 
    const onComplete = () => {
        answerIs.current = true
        setMessage('All notes have been defined.')
        setComplete(true)
    }
    const restart = () => {
        setComplete(false)
        selectedNote.current = 0
        setMessage(getInitialMessage())
        setMap(getHexMap())
        mod.current = new HexMapModifier(map)
    }
    const resetMessageForNextNote = () => {
        answerIs.current = null
        setMessage('Select the next note to define.')
    }
    const resetMessageForCurrentNote = () => {
        answerIs.current = null
        setMessage('Define this note.')
    }
    const onCorrect = () => {
        answerIs.current = true
        setMessage('Correct.')
        setTimeout(resetMessageForNextNote, 1000)
    }
    const notePlayer:MutableRefObject<NotePlayer> = useRef(useNotePlayer())
    const onNoteButtonClick = (noteTonic:number) => {
        const currentTonic:number = map.notes[selectedNote.current].params.tonic
        if(currentTonic === noteTonic){
            notePlayer.current.playNote(noteTonic, true)
            setMap(produce((draft:HexMap)=>{
                    mod.current.setDraft(draft)
                    mod.current.notes_setDefined([selectedNote.current], true)
                    if(draft.notes.filter((note:Note)=>{return !note.defined}).length === 0){
                        onComplete()
                    }
                    else{
                        onCorrect()
                    }
            }))
        }
        else{
            notePlayer.current.playBuzzer()
            answerIs.current = false
            setMessage('Incorrect.')
            setTimeout(resetMessageForCurrentNote, 1000)
        }
    }
    const getRestartButton = () => {
        return <div><button onClick={restart} type='button'>Restart</button></div>
    }
    return(
        <OutlineBox width={800}>
        <div className={'hex-builder'}>
            <ExerciseMessage key={Date.now()} message={message} answerStatus={answerIs.current}/>
            <svg width={600} height={400}>
                <g transform={TransformTranslate(300,200)}>
                    <HxMapGroup hexMap={map} onNoteClick={onNoteClick} onKeyClick={onKeyClick}>
                    </HxMapGroup>
                </g>
            </svg>
            {getRestartButton()}
            <NoteButtons key={'singleton'} onClick={onNoteButtonClick}/>
        </div>
        </OutlineBox>
        
    )
}